"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_analytics_provider_1 = require("./base-analytics-provider");
const messenger_js_sdk_1 = __importStar(require("@intercom/messenger-js-sdk"));
class IntercomProvider extends base_analytics_provider_1.BaseAnalyticsProvider {
    constructor(appId) {
        super();
        this.currrentUserId = null;
        this.appId = appId;
    }
    identifyUser(identity) {
        const registeredOn = identity.registeredOn
            ? Math.floor(new Date(identity.registeredOn).getTime() / 1000)
            : Math.floor(Date.now() / 1000);
        const { id, email, name, ...rest } = identity;
        if (this.isInitialized && this.currrentUserId === id) {
            (0, messenger_js_sdk_1.update)({ user_id: id, ...rest });
            return;
        }
        if (this.isInitialized && this.currrentUserId !== id) {
            (0, messenger_js_sdk_1.shutdown)();
            this.isInitialized = false;
        }
        if (id.length > 0 && (email === null || email === void 0 ? void 0 : email.length) > 0) {
            (0, messenger_js_sdk_1.default)({
                app_id: this.appId,
                user_id: id,
                email,
                name,
                created_at: registeredOn,
                ...rest
            });
        }
        else {
            (0, messenger_js_sdk_1.default)({
                app_id: this.appId
            });
        }
        this.isInitialized = true;
        this.currrentUserId = id;
    }
    updateUserIdentity(id, userProps) {
        (0, messenger_js_sdk_1.update)({
            updated_at: Math.floor(Date.now() / 1000),
            ...userProps
        });
    }
    track(eventName, properties) {
        return;
    }
    trackPage() {
        (0, messenger_js_sdk_1.update)({});
    }
    performLogout() {
        (0, messenger_js_sdk_1.shutdown)();
        this.isInitialized = false;
        this.currrentUserId = null;
    }
}
exports.default = IntercomProvider;
